import Page from 'attendee/theme/Page'
import {useI18n} from 'i18n/I18nContext'
import {useEventPreview} from 'event/providers/EventPreviewProvider'
import moment from 'moment'
import React, {useCallback, useEffect, useState} from 'react'
import styled from 'styled-components'

export function WaitPage() {
  const {t} = useI18n()
  const {event} = useEventPreview()

  const [remainingTime, setRemainingTime] = useState<null | {
    days: number
    hours: number
    minutes: number
    seconds: number
  }>(null)

  const calculateRemainingTime = useCallback(() => {
    const currentDate = moment(new Date())

    const eventStart = moment(
      `${event?.date} ${event?.time}`,
      'YYYY-MM-DD HH:mm',
    ).subtract(30, 'minutes')
    const pageDate = moment(event?.page_date)

    const targetDate = eventStart.isBefore(pageDate) ? eventStart : pageDate

    var duration = moment.duration(targetDate.diff(currentDate))

    const days = duration.days()
    const hours = duration.hours()
    const minutes = duration.minutes()
    const seconds = duration.seconds()

    if (duration.asMilliseconds() < 0) {
      window.location.reload()
    }
    if (duration.isValid()) {
      setRemainingTime({
        days,
        hours,
        minutes,
        seconds,
      })
    } else {
      setRemainingTime({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      })
    }
  }, [event?.date, event?.page_date, event?.time])
  useEffect(() => {
    calculateRemainingTime()
    const intervalId = setInterval(calculateRemainingTime, 1000)
    return () => {
      clearInterval(intervalId)
    }
  }, [calculateRemainingTime])

  if (!event) return null

  return (
    <Page>
      <section className="event__schedule-area dark_light_class pt-55 pb-150">
        <div className="container">
          <div className="row align-items-center">
            <TimerTitle className="banner__title">
              <div className="text__highlight" style={{whiteSpace: 'pre-line'}}>
                {t('attendee.waitTitle')}
              </div>
            </TimerTitle>

            <div className="banner__time">
              <CountDown className="count-down">
                {remainingTime && remainingTime.days}
                <span>{t('attendee.waitUnitDays')}</span>
              </CountDown>
              <CountDown className="count-down">
                {remainingTime && remainingTime.hours}
                <span>{t('attendee.waitUnitHours')}</span>
              </CountDown>
              <CountDown className="count-down">
                {remainingTime && remainingTime.minutes}
                <span>{t('attendee.waitUnitMinutes')}</span>
              </CountDown>
              <CountDown className="count-down">
                {remainingTime && remainingTime.seconds}
                <span>{t('attendee.waitUnitSeconds')}</span>
              </CountDown>
            </div>
          </div>

          <TextHolder>
            <span>{t('attendee.waitFootnote')}</span>
          </TextHolder>
        </div>
      </section>
    </Page>
  )
}

const TextHolder = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 50px;

  & > span {
    max-width: 620px;
    text-align: center;
  }
`

const CountDown = styled.div`
  & > span {
    font-size: 20px;
  }
`

const TimerTitle = styled.h3`
  font-size: 40px;
  text-align: center;

  @media (max-width: 575px),
    only screen and (min-width: 576px) and (max-width: 767px),
    only screen and (min-width: 768px) and (max-width: 991px) {
    font-size: 30px;
  }
`
